import { DataNode } from './form';
import { EvalRender, MobileLayoutNode } from './layout';

export function walkData(node: DataNode, visitor: (node: DataNode, path: string) => void, currentPath: string = ''): void {
  visitor(node, currentPath);

  if (node.properties !== undefined) {
    for (const [property, value] of Object.entries(node.properties)) {
      walkData(value, visitor, currentPath + '/properties/' + property);
    }
  }
}

// walkEval(node: EvalRender, visitor: (node: MobileLayoutNode, nodePath: string) => void): void;
export function walkEval(node: EvalRender, visitor: (node: MobileLayoutNode, nodePath: string) => void) {
  node.pages.forEach(function(e, a) {
    doWalkEval(e, '/pages/' + a, visitor);
  })
}

// todo characterize walkable node names, implement strategy here
function doWalkEval(e: any, r: any, a: (p: any, q: any) => any) {
  a(e, r);
  var t = undefined;
  var i: string;

  switch (e.type) {
    case 'Page':
      t = e.cards;
      i = '/cards';
      break;
    case 'Card':
    case 'View':
      t = e.children;
      i = '/children';
      break
  }

  if (t) {
    t.forEach(function(e: any, t: any) {
      doWalkEval(e, '' + r + i + '/' + t, a)
    })

  } else if (e.type === 'Dismissible') {
    doWalkEval(e.child, r + '/child', a)
  }
}
